var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 10.4336C11.6602 10.7852 11.6602 11.3125 11.3438 11.6289C10.9922 11.9805 10.4648 11.9805 10.1484 11.6289L6 7.44531L1.81641 11.6289C1.46484 11.9805 0.9375 11.9805 0.621094 11.6289C0.269531 11.3125 0.269531 10.7852 0.621094 10.4336L4.80469 6.25L0.621094 2.06641C0.269531 1.71484 0.269531 1.1875 0.621094 0.871094C0.9375 0.519531 1.46484 0.519531 1.78125 0.871094L6 5.08984L10.1836 0.90625C10.5 0.554688 11.0273 0.554688 11.3438 0.90625C11.6953 1.22266 11.6953 1.75 11.3438 2.10156L7.16016 6.25L11.3438 10.4336Z",
    fill: "#191926",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5c091674f2fbef96ec9b89d61a6f1c8f.svg";
export { ForwardRef as ReactComponent };